import { alpha } from "@mui/material";
import { color } from "html2canvas/dist/types/css/types/color";

export const sxMainBox = (theme: { palette: { mode: string } }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100dvw",
  position: "fixed",
  bottom: 24,
});
export const sxToggleButtonGroup = (theme: { palette: { mode: string } }) => ({
  backgroundColor: "background.default",
  "& .Mui-selected": {
    pointerEvents: "none",
  },
});
export const sxEmptyViewBox = (theme: { palette: { mode: string } }) => ({
  mt: 3,
  mb: 3,
  opacity: 0.4,
  textAlign: "center",
  backgroundImage:
    theme.palette.mode === "light"
      ? 'url("/static/images/templates/templates-images/hero-light.png")'
      : 'url("/static/images/templates/templates-images/hero-dark.png")',
  padding: "20px 20px",
  borderRadius: "10px",
  outline: "1px solid",
  outlineColor:
    theme.palette.mode === "light"
      ? alpha("#BFCCD9", 0.5)
      : alpha("#9CCCFC", 0.1),
});
export const sxResultViewBox = (theme: { palette: { mode: string } }) => ({
  mt: 3,
  mb: 3,
  backgroundImage:
    theme.palette.mode === "light"
      ? 'url("/static/images/templates/templates-images/hero-light.png")'
      : 'url("/static/images/templates/templates-images/hero-dark.png")',
  padding: "10px 20px",
  borderRadius: "10px",
  outline: "1px solid",
  outlineColor:
    theme.palette.mode === "light"
      ? alpha("#BFCCD9", 0.5)
      : alpha("#9CCCFC", 0.1),
});
export const sxLoadingViewBox = (theme: { palette: { mode: string } }) => ({
  borderRadius: "10px",
  outline: "1px solid",
  outlineColor:
    theme.palette.mode === "light"
      ? alpha("#BFCCD9", 0.5)
      : alpha("#9CCCFC", 0.1),
  padding: "20px 20px",
  display: "flex",
  justifyContent: "center",
  mt: 4,
  mb: 4,
});
